import Mapbox from 'index.vue';
import { BaseRasterLayer } from './baseRasterLayer';
export class TilesLayer extends BaseRasterLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance,'middle'); 
    }
    public DataChanged = async () => {
        this.RemoveAllLayers();
        let rasterLegend: any = null;
        this.mapboxInstance.model.areaSets.forEach((areaSet: any) => {
            if (this.mapboxInstance.areaSetVisible == areaSet.id && !areaSet.hover) {
                const regex = /([^0-9a-zA-Z]+)/g;
                const areaSetBlobName = areaSet.name.replace(regex, '-').toLowerCase();
                const tileUrl = `/api/tile-proxy/${areaSetBlobName}/{z}/{x}/{y}`;
                this.AddLayer(areaSet.id, tileUrl, areaSet.mapTilesZoomLevelsAvailable);
                // Raster tiles carry no colour data, so a legend can only come from the area set's
                // stored gradient (derived at import from AreaColors.csv). Show it when present.
                const colors = this.parseLegendColors(areaSet.legend);
                if (colors.length > 0) {
                    rasterLegend = { title: areaSet.title == null ? areaSet.name : areaSet.title, colors };
                }
            }
        });
        this.mapboxInstance.$emit('rasterLegendChanged', rasterLegend);
    };

    private parseLegendColors(legend: any): string[] {
        if (legend == null) return [];
        if (Array.isArray(legend)) return legend;
        try {
            const parsed = JSON.parse(legend);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
}